import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';
import { ReportCommentary } from './ReportCommentary';

const COLUMNS: ReportColumn[] = [
  { key: 'asset_class', label: 'Asset Class' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'percent', label: '% of Portfolio', align: 'right', type: 'percent' },
  { key: 'policy_min', label: 'Target Min', align: 'right', type: 'percent' },
  { key: 'policy_max', label: 'Target Max', align: 'right', type: 'percent' },
  { key: 'breach', label: 'Status', sortable: false },
];

// No status/category/dateRange filters — every asset class always appears
// (even at zero holdings), so there is nothing meaningful to filter by;
// see InvestmentReportController::assetAllocationData().
export function AssetAllocationReport() {
  return (
    <>
      <ReportView
        title="Asset Allocation"
        description="Current portfolio allocation by asset class, checked against each class's policy range."
        endpoint="/reports/investments/allocation"
        columns={COLUMNS}
      />
      <ReportCommentary />
    </>
  );
}
